import './logistics-vehicle-location-pn.constant';
